import { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * CollapsibleCard — slim accordion wrapper for Vermittler-Dashboard sections.
 *
 * Mirrors the SectionToggle pattern used in CreateListingPage but renders
 * the body inside its own white card so existing children (BankForm etc.)
 * keep their visual identity.
 */
export default function CollapsibleCard({
    title,
    icon: Icon,
    hint,
    testId,
    defaultOpen = false,
    children,
}) {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div data-testid={testId}>
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="w-full flex items-center gap-3 px-6 py-4 bg-white border border-gray-200 rounded-sm hover:bg-gray-50 transition-colors text-left mb-2"
                data-testid={testId ? `${testId}-btn` : undefined}
                aria-expanded={open}
            >
                {Icon && (
                    <div className="w-9 h-9 bg-[#FFCC00] flex items-center justify-center rounded-sm shrink-0">
                        <Icon className="w-4 h-4 text-[#111827]" strokeWidth={2.5} />
                    </div>
                )}
                <div className="flex-1 min-w-0">
                    <h2 className="font-display text-lg font-bold leading-tight">{title}</h2>
                    {hint && <p className="text-xs text-gray-500 mt-0.5">{hint}</p>}
                </div>
                <ChevronDown
                    className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${open ? "rotate-180" : ""}`}
                    aria-hidden="true"
                />
            </button>
            {open && (
                <div className="space-y-4" data-testid={testId ? `${testId}-body` : undefined}>
                    {children}
                </div>
            )}
        </div>
    );
}
